import currencydata from "../data/currencydata";

export const fetchCurrency = (type) => {
  return (
    currencydata.find(
      (each) =>
        each.id == type ||
        each.id?.toLocaleLowerCase() == type?.toLocaleLowerCase()
    ) || currencydata[0]
  );
};
